import React from 'react';
import PropTypes from 'prop-types';

import IconRejected from 'icons/Rejected';
import IconAccepted from 'icons/Accepted';
import { ReactComponent as IconInfo } from 'icons/Info.svg';
import Close from 'icons/Close';

import AlertMsgWrapper from './AlertMsgWrapper';
import IconsContainer from './IconsContainer';
import Header from './Header';
import PositionMsg from './PositionMsg';
import CloseBtn from './CloseBtn';

const SETTINGS = {
  ERROR: {
    title: 'Ошибка',
    icon: IconRejected,
  },
  SUCCESS: {
    title: 'Успешно',
    icon: IconAccepted,
  },
  WARNING: {
    title: 'Предупреждение',
    icon: IconInfo,
  },
};

class AlertMsg extends React.PureComponent {
  get settings() {
    if (this.props.classNames.indexOf('s-alert-success') !== -1) {
      return SETTINGS.SUCCESS;
    } if (this.props.classNames.indexOf('s-alert-warning') !== -1) {
      return SETTINGS.WARNING;
    }

    return SETTINGS.ERROR;
  }

  render() {
    return (
      <AlertMsgWrapper
        className={this.props.classNames}
        id={this.props.id}
        style={this.props.styles}
      >
        <IconsContainer>{<this.settings.icon />}</IconsContainer>

        <div className="s-alert-box-inner">
          <Header>{this.settings.title}</Header>

          <PositionMsg>{this.props.message}</PositionMsg>
        </div>

        <CloseBtn
          type="button"
          onClick={this.props.handleClose}
          role="button"
          aria-label="Закрыть"
          tabIndex="-1"
        >
          <Close size={12} />
        </CloseBtn>
      </AlertMsgWrapper>
    );
  }
}

AlertMsg.defaultProps = {
  styles: {},
};

AlertMsg.propTypes = {
  id: PropTypes.string.isRequired,
  classNames: PropTypes.string.isRequired,
  styles: PropTypes.shape({}),
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AlertMsg;
